<template>
  <div class="containerdiv">
    <!-- 空白页 -->
    <div v-if="!hasLogin || empty === true" class="empty">
      <van-image
        lazy-load
        width="120"
        height="80"
        :src="require('@/static/emptyCart.jpg')"
      />
      <div v-if="hasLogin" class="empty-tips">
        空空如也
        <router-link to="/pages/category/category" class="navigator"
          >随便逛逛></router-link
        >
      </div>
      <div v-else class="empty-tips">
        空空如也
        <!-- <div class="navigator" @click="navToLogin">去登陆></div> -->
      </div>
    </div>
    <!-- 列表 -->
    <div class="cart-list" v-if="empty === false && cartList.length > 0">
      <div class="cart-list-top">
        <div class="checkbox">
          <div
            :class="allChecked ? 'active' : ''"
            class="checkbox-box"
            @click="check('all')"
          ></div>
          <span>全选</span>
        </div>
        <div class="edit" @click="showBtn = !showBtn">
          {{ showBtn ? "完成" : "管理" }}
        </div>
      </div>

      <div
        v-for="(item, index) in cartList"
        :key="item.cartId"
        class="cart-card"
      >
        <van-swipe-cell>
          <div class="cart-item">
            <div
              :class="item.selected ? 'active' : ''"
              class="checkbox-box"
              @click="check('item', index)"
            ></div>
            <div class="image-wrapper" @click="itemClick(item.productId)">
              <van-image
                lazy-load
                :src="item.picture || item.stockPicture"
                class="image-wrapper-image"
                mode="aspectFill"
                @error="onImageError('cartList', index)"
              />
            </div>
            <div class="item-right">
              <span class="clamp title" @click="itemClick(item.productId)">{{
                item.name
              }}</span>
              <span class="attr" @click="itemClick(item.productId)">{{
                item.description
              }}</span>
              <div class="price-step">
                <div class="price" @click="itemClick(item.productId)">
                  ¥{{ item.price.toFixed(2) }}
                  <span v-if="item.isIntegral === 1"
                    >+{{ item.mostIntegralCanUse }}积分</span
                  >
                </div>
              </div>
              <div class="price-step">
                <uni-number-box
                  class="step"
                  :disabled="true"
                  :min="1"
                  :max="
                    item.productStockId == null
                      ? item.stock * 1
                      : item.stockQuantity * 1
                  "
                  :value="item.quantity * 1"
                  :isMax="
                    item.quantity * 1 >=
                    (item.productStockId == null
                      ? item.stock * 1
                      : item.stockQuantity * 1)
                      ? true
                      : false
                  "
                  :isMin="
                    (item.productStockId == null
                      ? item.stock * 1
                      : item.stockQuantity * 1) >= 1
                  "
                  :index="index"
                  @eventChange="numberChange"
                ></uni-number-box>
              </div>
            </div>
          </div>
          <template #right>
            <van-button
              square
              type="danger"
              text="删除"
              class="delete-button"
              @click="deleteCartItem(index)"
            />
          </template>
        </van-swipe-cell>
      </div>
    </div>
    <!-- 底部菜单栏 -->
    <div class="action-section" v-if="cartList.length > 0">
      <div class="total-box" v-if="!showBtn">
        <span class="total-num">共{{ totalNum }}件商品</span>
        <span class="price">¥{{ total.toFixed(2) }}</span>
        <span v-if="totalPoint > 0" class="price" style="font-size: 12px"
          >可用{{ cartData.mostPointCanUse }}积分抵{{
            cartData.mostMoneyCanDeduct
          }}元</span
        >
        <!-- <span class="coupon">
						已优惠
						<span>74.35</span>
						元
        </span>-->
      </div>
      <div class="no-border confirm-btn" @click="createOrder" v-if="!showBtn">
        去结算
      </div>
      <div class="no-border delete-btn" @click="clearCart" v-else>删除</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import uniNumberBox from "@/components/uni-number-box.vue";
export default {
  components: {
    uniNumberBox,
  },
  data() {
    return {
      total: 0, //总价格
      totalPoint: 0, //总积分
      allChecked: false, //全选状态  true|false
      empty: false, //空白页现实  true|false
      cartList: [],
      cartData: {},
      showBtn: false,
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    //显示空白页
    cartList(e) {
      let empty = e.length === 0 ? true : false;
      if (this.empty !== empty) {
        this.empty = empty;
      }
    },
  },
  computed: {
    ...mapState(["hasLogin"]),
    totalNum() {
      let totalNum = 0;
      this.cartList.forEach((item) => {
        if (item.selected) {
          totalNum += item.quantity;
        }
      });
      return totalNum;
    },
  },
  methods: {
    //请求数据
    loadData() {
      if (this.hasLogin) {
        this.getCartList();
      }
    },
    getCartList() {
      this.$http.request(this.$http.pathMap.cartList).then((res) => {
        res.data.carList.forEach((item) => {
          item.stockQuantity = item.stockQuantity || item.stock;
        });
        this.cartList = res.data.carList;
        this.cartData = res.data;
        this.calcTotal();
      });
    },
    //监听image加载失败
    onImageError(key, index) {
      this[key][index].image = "/static/errorImage.jpg";
    },
    navToLogin() {
      this.$router.push("/pages/public/login");
    },
    //选中状态处理
    check(type, index) {
      let that = this;
      if (type === "item") {
        let item = that.cartList[index];
        that.$http
          .request(that.$http.pathMap.cartSelected, "get", {
            cartId: item.cartId,
            selected: !item.selected,
          })
          .then((res) => {
            that.getCartList();
            that.calcTotal(type);
          });
      } else {
        const selected = !that.allChecked;
        that.$http
          .request(that.$http.pathMap.cartSelectedBatch, "get", {
            selected,
          })
          .then((res) => {
            that.allChecked = selected;
            that.getCartList();
            that.calcTotal(type);
          });
      }
    },
    //数量
    numberChange(data) {
      let cart = this.cartList[data.index];
      this.$http
        .request(this.$http.pathMap.cartQuantity, "get", {
          cartId: cart.cartId,
          quantity: data.number,
        })
        .then((res) => {
          this.getCartList();
        });
    },
    //删除
    deleteCartItem(index) {
      let list = this.cartList;
      let row = list[index];
      let cartId = row.cartId;
      this.$http
        .request(this.$http.pathMap.cartDelete + "/" + cartId, "get")
        .then((res) => {
          this.$toast("删除成功");
          this.getCartList();
        });
    },
    //清空
    clearCart() {
      console.log(this.cartList);
      let selectedCart = [];
      selectedCart = this.cartList.filter((item) => item.selected);
      console.log(selectedCart, "@");
      if (selectedCart.length == 0) return this.$toast("请选择要删除的商品");
      let ids = selectedCart.map((item) => item.cartId);
      console.log(ids);
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除吗？",
        })
        .then(() => {
          this.$http
            .request(this.$http.pathMap.deleteCart, "post", ids)
            .then((res) => {
              this.$toast("删除成功");
              this.getCartList();
            });
        });
    },
    //计算总价
    calcTotal() {
      let list = this.cartList;
      if (list.length === 0) {
        this.empty = true;
        return;
      }
      let total = 0;
      let totalPoint = 0;
      let checked = true;
      list.forEach((item) => {
        if (item.selected === true) {
          total += item.price * item.quantity;
          if (item.gifted) {
            totalPoint += item.price * item.quantity;
          }
        } else if (checked === true) {
          checked = false;
        }
      });
      this.allChecked = checked;
      this.total = Number(total.toFixed(2));
      this.totalPoint = Number(totalPoint.toFixed(2));
    },
    //创建订单
    createOrder() {
      let selectedCart = [];
      selectedCart = this.cartList.filter((item) => item.selected);
      console.log(selectedCart, "@");
      if (selectedCart.length == 0) return this.$toast("请先选择商品");
      let list = this.cartList;
      let goodsData = [];
      list.forEach((item) => {
        if (item.checked) {
          goodsData.push({
            attr_val: item.attr_val,
            number: item.number,
          });
        }
      });
      this.$router.push({
        name: "CreateOrder",
        params: { refreshData: this.loadData,categoryType:1 },
      });
    },
    itemClick(id) {
      this.$router.push({
        path: "/pages/product/product",
        query: {
          id,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.containerdiv {
  background-color: #f5f5f5;
  padding-bottom: 120px;

  /* 空白页 */
  .empty {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    padding-bottom: 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: #fff;

    img {
      width: 120px;
      height: 80px;
      margin-bottom: 15px;
    }

    .empty-tips {
      display: flex;
      font-size: $uni-font-size-sm + 1px;
      color: $font-color-disabled;

      .navigator {
        color: var(--theme-font-color);
        margin-left: 8px;
      }
    }
  }
}
.delete-button {
  height: 100%;
}
.star-button {
  height: 100%;
}
.checkbox-box {
  width: 18px;
  height: 18px;
  opacity: 1;
  border: 1px solid #dbdbdb;
  border-radius: 50%;
  position: relative;
}
.active::before {
  display: inline-block;
  content: " ";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #496bcb;
  opacity: 1;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cart-list {
  margin: 14px;
  background: #fff;
  border-radius: 10px;
  padding-top: 10px;
  .cart-list-top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dbdbdb;
    padding: 0 10px 10px 0;
    .checkbox {
      margin-left: 17px;
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
        font-size: 14px;
      }
    }
    .edit {
      font-size: 14px;
      color: #496bcb;
    }
  }
}
/* 购物车列表项 */
.cart-item {
  display: flex;
  position: relative;
  padding: 15px 15px;
  align-items: center;

  .image-wrapper {
    flex: 1;
    height: 115px;
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 10px;

    .image-wrapper-image {
      border-radius: 4px;
      width: 115px;
      height: 115px;
      overflow: hidden;
      margin-right: 5px;
      margin-left: 5px;
    }
  }

  .item-right {
    flex: 2;
    overflow: hidden;
    position: relative;
    padding-left: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 115px;
    .price-step {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .step {
        flex: 1;
        position: relative;
        left: 50px;
      }
      .price {
        height: 25px;
        line-height: 25px;
        color: #e43131;
      }
    }
    .title {
      font-size: $uni-font-size-base + 1px;
      color: $font-color-dark;
      height: 20px;
      line-height: 20px;
    }

    .attr {
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出则不换行
      font-size: $uni-font-size-sm + 1px;
      color: $font-color-light;
      height: 25px;
      line-height: 25px;
    }
  }

  .del-btn {
    padding: 2px 5px;
    font-size: 17px;
    height: 25px;
    color: $font-color-light;
  }
}
/* 底部栏 */
.action-section {
  /* #ifdef H5 */
  margin-bottom: 65px;
  justify-content: end;
  /* #endif */
  position: fixed;
  bottom: 4px;
  z-index: 95;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1px solid #eee;

  .total-box {
    flex: 1;
    text-align: right;
    padding-right: 20px;
    .total-num {
      font-size: 12px;
      color: #999;
      margin-right: 10px;
    }
    .price {
      font-size: 18px;
      color: #e43131;
    }

    .coupon {
      font-size: $uni-font-size-sm;
      color: $font-color-light;

      text {
        color: $font-color-dark;
      }
    }
  }

  .confirm-btn {
    padding: 0 19px;
    margin: 0;
    border-radius: 100px;
    height: 38px;
    color: white;
    line-height: 38px;
    font-size: $uni-font-size-base + 1px;
    background: #496bcb;
  }
  .delete-btn {
    padding: 0 19px;
    margin: 0;
    border-radius: 100px;
    height: 38px;
    color: #999999;
    width: 100px;
    text-align: center;
    line-height: 38px;
    font-size: $uni-font-size-base + 1px;
    border: 1px solid #999999;
  }
}

/* 复选框选中状态 */
.action-section .checkbox.checked,
.cart-item .checkbox.checked {
  color: var(--theme-font-color);
}
</style>
